import axios from "../utils/axios_interceptor"
import { getPdmApiUrl } from "./helper";

const getConsigneeData = () => {
  if (typeof window === "undefined") return {};
  const onBehalfData = JSON.parse(localStorage.getItem("onbehalf"));

  if (!onBehalfData) return {};
  return {
    consigneeAda: onBehalfData.ada,
    consigneeType: onBehalfData.loginType,
    consigneeMemberType: onBehalfData.loginMemberType,
  };
};

export const addToCart = async (
  itemCode,
  quantity = 1,
  additionalData = {},
  adaObj = {}
) => {
  const apiUrl = getPdmApiUrl();

  return axios.post(
    `/add-to-cart`,
    {
      itemCode,
      quantity: quantity,
      ...additionalData,
      ...getConsigneeData(),
      ...adaObj
    },
    {
      baseURL: apiUrl,
    }
  );
};

export const batchAddToCart = async (products, additionalData = {}) => {
  const apiUrl = getPdmApiUrl();

  return axios.post(
    `/batch-add-to-cart`,
    {
      products,
      ...additionalData,
      ...getConsigneeData(),
    },
    {
      baseURL: apiUrl,
    }
  );
};

export const addToWishlist = async (productCode) => {
  const apiUrl = getPdmApiUrl();
  return axios.post(
    `/add-to-collection`,
    {
      productCode,
    },
    {
      baseURL: apiUrl,
    }
  );
};

export const removeToWishlist = async (productCode) => {
  const apiUrl = getPdmApiUrl();
  return axios.post(
    `/remove-from-collection`,
    {
      collectionList: [{ productCode }],
    },
    {
      baseURL: apiUrl,
    }
  );
};

export const calculateBundleTotal = async (
  promotionCode,
  promotionItemList,
  additionalData = {}
) => {
  const apiUrl = getPdmApiUrl();

  const res = await axios.post(
    `/calculate-bundle-total`,
    {
      promotionCode,
      promotionItemList,
      ...additionalData,
    },
    {
      baseURL: apiUrl,
    }
  );
  return res.data;
};

export const getProductInfo = async (itemCode) => {
  if (typeof window === "undefined") return {};
  const onBehalfData = JSON.parse(localStorage.getItem("onbehalf"));
  // if (!onBehalfData) return {};
  const apiUrl = getPdmApiUrl();
  const res = await axios.post(
    `/products/${itemCode}`,
    {
      aboNumber: onBehalfData?.ada,
    },
    {
      baseURL: apiUrl,
    }
  );
  return res;
};

export const getProductActivity = async (
  itemCode,
) => {
  const apiUrl = getPdmApiUrl();

  return axios.post(
    `/get-product-activity`,
    {
      itemCode,
    },
    {
      baseURL: apiUrl,
    }
  );
};